import { useEffect, useState } from "react";
import { apiClient } from "../lib/api";

/** Polls the order-chat unread count for a Chat icon badge (Order Detail,
 * Incoming Order Detail, Employee Task Detail). Silent on error/403 so a
 * non-participant viewer (shouldn't happen, but defensive) just sees 0. */
export function useChatUnread(orderId) {
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!orderId) return undefined;
    let mounted = true;
    const load = () => {
      apiClient.get(`/orders/${orderId}/messages/unread-count`)
        .then((r) => { if (mounted) setUnread(r.data?.unread || 0); })
        .catch(() => {});
    };
    load();
    const id = setInterval(load, 5000);
    return () => { mounted = false; clearInterval(id); };
  }, [orderId]);

  return unread;
}
